import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {selectors} from '../../Redux/index';
import GridItem from '../../Components/Grid/GridItem';
import { waitFor } from '@testing-library/react';


/**
 * Single Container for the dashboard view. It contains a set of widgets [<GridItem />]
 * The container is determined by its containerId.
 */
const GridContainer = (props) => {
    let className = 'grid-layout__container grid-layout__container--' + props.containerId;
    
    console.log("Widgets: ",props.widgets );
    console.log("isArray: ",Array.isArray(props.widgets));
    return (
        <div className={className}>
            {props.children}
            {props.widgets ? props.widgets.map((widget, index) => (
                <GridItem key={`widget-${index}`} {...widget} locale={props.locale} />
            )) : null}
        </div>
    )
};

const makeMapStateToProps = () => {
  return (state, props) => {
    // 🔴 create selector INSIDE here
    const widgetTypeConfiguration =
      selectors.Data.Dashboard.widgetsByContainerIdFactory();
 
const widgetsRaw =
  widgetTypeConfiguration(state, props.containerId);
 
let widgets =
  widgetsRaw?.toJS ? widgetsRaw.toJS() : widgetsRaw;
 
widgets = widgets?.map(w => {
  let chart = w.chartData;
 
  // 🔥 if chartData empty but ts exists → use ts
  if ((!chart || chart.length === 0) && Array.isArray(w.ts)) {
    chart = w.ts;
  }
 
  // ensure array
  if (chart && !Array.isArray(chart)) {
    chart = [chart];
  }
 
  return {
    ...w,
    chartData: chart || []
  };
});
 
return {
  widgets,
  locale: selectors.UI.Locale.getLocale(state)
};
  };
};

GridContainer.propTypes = {
    /**
     * the id of this container
     */
    containerId: PropTypes.string.isRequired,

    /**
     * widget data as described in <GridItem />
     */
    widgets: PropTypes.arrayOf(
        PropTypes.shape(GridItem.propTypes)
    ),
    locale: PropTypes.string

};

export default connect(makeMapStateToProps)(GridContainer);